module.exports = __webpack_public_path__ + "img/eco7.3c4da477.png";